import type { CustomerRevenueReportItem } from '@vy/types';
import { applyReportSearch } from '../../reports-components/apply-report-search';

export function applyCustomerRevenueSearch(
  reportItems: CustomerRevenueReportItem[],
  searchText: string | null | undefined,
): CustomerRevenueReportItem[] {
  return applyReportSearch(reportItems, searchText, (item) => [
    item.customer.name,
    item.productVariant?.name,
    item.revisionedLineItem?.name,
  ]);
}
